import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import StandardButton from 'design-system/Buttons/StandardButton'
import Body2 from 'design-system/Typography/Body/Body2'
import Heading3 from 'design-system/Typography/Heading/Heading3'

import Modal from 'components/Modal'
import Spacer from 'components/Spacer'

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export interface INoResultsModalProps {
  searchedAddress: string
  noResultsModalVisible: boolean
  setNoResultsModalVisible: (visible: boolean) => void
}

const NoResultsModal: FunctionComponent<INoResultsModalProps> = ({
  searchedAddress,
  noResultsModalVisible,
  setNoResultsModalVisible,
}) => {
  const theme = useContext(ThemeContext)

  const handleClose = () => setNoResultsModalVisible(false)

  return (
    <Modal
      visible={noResultsModalVisible}
      setVisible={setNoResultsModalVisible}
      onClose={handleClose}
      padding={`${theme.spacings[48]}px`}
      maxWidth={736}
      closeButtonColor={theme.colors.white}
      closeButton
      closeButtonFixed
      closeButtonTopPosition={theme.spacings[32]}
      closeButtonRightPosition={theme.spacings[48]}
      closeText
      closeTextFontSize="14px"
      closeTextLineHeight="19px"
      closeTextFontWeight={400}
      closeTextUpperCase
    >
      <Spacer size={theme.spacings[16]} />
      <CenteredContainer>
        <Heading3>{`We couldn't find ‘${searchedAddress}’.`}</Heading3>
        <Spacer size={theme.spacings[16]} />
        <Body2>
          Check that your location is spelled correctly and is within the continental United States.
        </Body2>
        <Spacer size={theme.spacings[36]} />
        <StandardButton
          type="primary"
          size="medium"
          label="Try Another Search"
          onClick={handleClose}
        />
      </CenteredContainer>
    </Modal>
  )
}

export default NoResultsModal
